import styled from 'styled-components';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { Contenedor, TituloPagina, Subtitulo } from '../components/layout/Layout';

const Cuadricula = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.lg};
  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Datos = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.md};

  h2 {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.sageDeep};
  }

  p {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 0.95rem;
  }
`;

const Mapa = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 320px;
  border: 0;
  border-radius: ${({ theme }) => theme.radii.md};
`;

const Redes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.sm};
`;

function Contacto() {
  return (
    <Contenedor>
      <TituloPagina>Contacto</TituloPagina>
      <Subtitulo>Estamos en una sola sucursal, en el corazón de la colonia Roma.</Subtitulo>
      <Cuadricula>
        <Datos>
          <div>
            <h2>Dirección</h2>
            <p>Av. Álvaro Obregón 120, Roma Norte, CDMX</p>
          </div>
          <div>
            <h2>Horarios</h2>
            <p>Lunes a viernes · 7:00 am — 8:30 pm</p>
            <p>Sábado · 8:00 am — 1:00 pm</p>
          </div>
          <div>
            <h2>Escríbenos</h2>
            <Redes>
              <Button
                as="a"
                href="https://wa.me/5215500000000"
                target="_blank"
                rel="noreferrer"
                $chico
              >
                WhatsApp
              </Button>
              <Button
                as="a"
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                $variante="secundario"
                $chico
              >
                Instagram
              </Button>
              <Button as="a" href="mailto:hola@numa.mx" $variante="fantasma" $chico>
                hola@numa.mx
              </Button>
            </Redes>
          </div>
        </Datos>
        <Mapa
          title="Mapa de ubicación del estudio"
          src="https://www.openstreetmap.org/export/embed.html?bbox=-99.1706%2C19.4152%2C-99.1556%2C19.4232&layer=mapnik&marker=19.4192%2C-99.1631"
          loading="lazy"
        />
      </Cuadricula>
    </Contenedor>
  );
}

export default Contacto;
